import { View } from "tamagui";
import { RouteProp, useRoute } from "@react-navigation/native";
import { ProfileNavigatorParamList } from "../../navigators/ProfileNavigator";
import { Member } from "./Member";

export const MemberQueryRenderer = () => {
  const route = useRoute<RouteProp<ProfileNavigatorParamList, "Member">>();
  const userId = route.params.id;

  return (
    <View bg="$brandParchment" flex={1}>
      <Member userId={userId} />
    </View>
  );
};
